import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';

import { ROUTES } from '../constants/routes';
import { isKnownAccountPath } from '../paths/isKnownRoute';
import AccountSettings from './AccountSettings/AccountSettings';

const GuardedAccountSettings = (props) => {
  const { pathname } = useLocation();

  if (!isKnownAccountPath(pathname)) {
    return <Redirect to={ROUTES.LOGIN} />;
  }

  return <AccountSettings {...props} />;
};

export default GuardedAccountSettings;
